import React, {FC, useRef, useState} from 'react'
import {Button} from "../inputs/Button"
import {Input} from "../inputs/Input"
import {TemplateType, DocumentPartTemplateData} from '@dv5/domain'
import './SaveTemplateDialog.less'

interface Props {
    title: string
    templateType: TemplateType
    onSave: (title: string) => void
    onCancel: () => void
}

export const SaveTemplateDialog: FC<Props> = ({
                                                   title,
                                                   templateType,
                                                   onSave,
                                                   onCancel,
                                               }) => {
    const [templateTitle, setTemplateTitle] = useState('')
    const [errorMessage, setErrorMessage] = useState('')
    const dialogRef = useRef<HTMLDivElement>(null)

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (dialogRef.current && !dialogRef.current.contains(e.target as Node)) {
            onCancel()
        }
    }

    const handleSave = () => {
        if (!templateTitle.trim()) {
            setErrorMessage('Template title is required')
            return
        }
        onSave(templateTitle.trim())
    }

    const handleCancel = () => {
        setTemplateTitle('')
        setErrorMessage('')
        onCancel()
    }

    const handleInputChange = (value: string) => {
        setTemplateTitle(value)
        if (errorMessage) {
            setErrorMessage('')
        }
    }

    return (
        <div className="save-template-dialog-overlay" onClick={handleOverlayClick}>
            <div className="save-template-dialog" ref={dialogRef}>
                <h3>{title}</h3>
                <div className="template-type-info">
                    <span className="label">Type: </span>
                    <span className="value">{templateType}</span>
                </div>
                <div className="input-container">
                    <Input
                        id="templateTitle"
                        label="Template Title"
                        value={templateTitle}
                        placeholder="Enter template title"
                        autoFocus={true}
                        setValue={handleInputChange}
                        onConfirm={handleSave}
                        onCancel={handleCancel}
                    />
                </div>
                {errorMessage && (
                    <div className="error-message">{errorMessage}</div>
                )}
                <div className="buttons">
                    <Button title="Cancel" onClick={handleCancel} className="cancel-dialog-button" />
                    <Button title="Save" onClick={handleSave} className="save-dialog-button" />
                </div>
            </div>
        </div>
    )
}
